/**
 * The comments feature's framework-free entry point: comment types and pure
 * functions, and nothing that loads React, the query client or the HTTP
 * client. Import from here rather than the main entry when that is all you
 * need, so a pure helper does not drag the adapter in behind it.
 */
export type {
  AnyComment,
  Comment,
  CommentAuthor,
  CommentAvatar,
  CommentReply,
  NewComment,
} from './types';

export { anonymousAliasFor } from './anonymousAlias';

export {
  getAnonymousName,
  getCommentIsAnonymous,
  getDisplayName,
  getInitials,
  getReplyToName,
  getStateName,
} from './authorDisplay';

export { commentsHeading, countWithReplies } from './threadCount';
